import { DownloadOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, DatePickerProps, Row } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { xuatExcelNguoiPhuThuocTrongNam } from '../../../services/nhanvien';
import { hideLoadingScreen, showLoadingScreen } from '../../../store/reducers/loading';

const NguoiPhuThuocThongKe = () => {
    const dispatch = useDispatch();
    const [nam, setNam] = useState<string>(new Date().getFullYear().toString());
    const [namValue, setNamValue] = useState<Dayjs | null>(dayjs());

    const namFormat: DatePickerProps['format'] = (value) => `Năm ${value.format('YYYY')}`;

    const handleExport = async () => {
        if (!nam) {
            toast.warning('Vui lòng chọn năm trước khi xuất Excel');
            return;
        }
        dispatch(showLoadingScreen());
        try {
            const response = await xuatExcelNguoiPhuThuocTrongNam(parseInt(nam));
            const link = document.createElement('a');
            link.download = `ThongKeNguoiPhuThuocNam${nam}.xlsx`;
            const blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (err: any) {
            toast.error('Xuất báo cáo không thành công. Vui lòng thử lại');
        } finally {
            dispatch(hideLoadingScreen());
        }
    };

    return (
        <div style={{ marginTop: '23px' }}>
            <Row gutter={10}>
                <Col span={4}>
                    <label>Người phụ thuộc:</label>
                </Col>
                <Col span={5}>
                    <DatePicker
                        changeOnBlur={true}
                        value={namValue}
                        style={{ width: '100%' }}
                        placeholder="Năm"
                        picker="year"
                        format={namFormat}
                        onChange={(year: Dayjs | null) => {
                            setNamValue(year);
                            setNam(year?.format('YYYY') ?? '');
                        }}
                        allowClear={false}
                    />
                </Col>
                <Col>
                    <Button
                        className="hrm-btn hrm-btn-success"
                        icon={<DownloadOutlined />}
                        onClick={handleExport}
                    >
                        Xuất excel
                    </Button>
                </Col>
            </Row>
        </div>
    );
};

export default NguoiPhuThuocThongKe;
